import clientAxios from '../../config/axios';
import { configOptions } from '../../helpers/axios';

export const getLoanP2PKeyByID = (token: string, filter: any) => {
  const url = `/loans/p2p/key?country=${process.env.REACT_APP_ENV_COUNTRY}${filter}`;
  return clientAxios.get(url, configOptions(token));
};
